import auth from "@/middleware/auth";

export default [
    {
        path: "meusBoletos",
        name: "meusBoletos",
        meta: { middleware: [auth] },
        component: () => import("./MeusBoletos")
    }
];
